import React, { Component } from 'react';
import TweenMax from 'gsap/TweenMax';


class SideBar extends Component {
  state = {
    sb: {
      sBLeftMargin: -10,
      collapsed: true,
      buttonPos: 10
    }

  }

  sBAnimation = () => {
    const myObj = {
      margin: this.state.sb.sBLeftMargin
    }
    if(this.state.sb.collapsed) {
      TweenMax.to(myObj, 0.25, {margin: 0, onUpdate: () => {
        this.setState({sb:{sBLeftMargin: myObj.margin, collapsed: false, buttonPos: 0}});
      }})
    }
    else {
      TweenMax.to(myObj, 0.25, {margin: -10, onUpdate: () => {
        this.setState({sb:{sBLeftMargin: myObj.margin, collapsed: true, buttonPos: 10}});
      }})
    }
  }


  render () {
    const sideBarStyle = {
      background: 'yellow',
      height: '100vh',
      width: '11vw',
      marginLeft: this.state.sb.sBLeftMargin + 'vw',
      borderRight: 'solid black 1px',
      zIndex: 2
    }
    const rButtonStyle = {
      background: 'white',
      height: '100vh',
      width: '1vw',
      marginLeft: this.state.sb.buttonPos + 'vw'
    }
    return (
      <div className="position-absolute" style={sideBarStyle}>
        <div className='' style={rButtonStyle} onClick={this.sBAnimation}></div>
      </div>
    )
  }
}

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js